import {
  Box,
  Grid,
  Typography,
  Hidden,
  IconButton,
  LinearProgress,
  CardMedia,
} from '@mui/material';
import React, { useEffect, useState } from 'react';
import PersonOutlineOutlinedIcon from '@mui/icons-material/PersonOutlineOutlined';
import { useHistory } from 'react-router';
import NavigateBeforeIcon from '@mui/icons-material/NavigateBefore';
import { Gridstyles } from '../ApplicationDetails';
import { useDispatch } from 'react-redux';
import { KeyValue } from '../ApplicationDetails/contributor';
import { RmsType, SubDistributorListType } from '../../redux-store/types/api-types';
import { getDistributorRMbyId, getRMById } from '../../redux-store/actions/userManagement';
import { Location } from 'history';
import { checkApplicableForYes } from '../../utils/utilityFunctions';
import { mappingRmWithDistributors } from '../../utils/constant';

export default function DistributorRmDetails({
  location,
}: {
  location: Location<{ subDistributorId: number }>;
}): JSX.Element {
  const { subDistributorId: id } = location.state || { subDistributorId: null };
  const history = useHistory();
  const dispatch = useDispatch();
  const [isLoading, setLoading] = useState(false);
  const [distributorRmDetails, setDistributorRmDetails] = useState<SubDistributorListType>();

  useEffect(() => {
    let isComponentActive = true;
    (async function () {
      try {
        setLoading(true);
        if (id) {
          const getDistributorRmDetails = (await dispatch(
            getDistributorRMbyId(id)
          )) as unknown as SubDistributorListType;
          setDistributorRmDetails(getDistributorRmDetails);
        }
        if (!isComponentActive) {
          return;
        }
        setLoading(false);
      } catch (e) {
        setLoading(false);
        console.log((e as Error).message);
      }
    })();
    return () => {
      isComponentActive = false;
    };
  }, []);

  return (
    <>
      <Box
        sx={{
          bgcolor: 'white',
          boxShadow: '0px 4px 12px rgba(0, 0, 0, 0.05)',
          borderRadius: '10px',
          py: { xs: 2, sm: 5 },
          px: { xs: 0, sm: 5 },
          mt: { xs: 2, sm: 5 },
        }}>
        <Hidden smUp={true}>
          <Box sx={{ display: 'flex', alignItems: 'center' }}>
            <IconButton
              sx={{ height: 'fit-content', p: 0 }}
              onClick={() =>
                history.push('distributors-rm', {
                  distributorId: distributorRmDetails?.distributorId,
                  isRia: distributorRmDetails?.isRia,
                })
              }>
              <NavigateBeforeIcon fontSize="medium" sx={{ color: 'common.black' }} />
            </IconButton>
            <Typography
              sx={{
                fontSize: 20,
                fontWeight: 600,
                color: '#1C2D47',
              }}>
              Back
            </Typography>
          </Box>
          <Box
            sx={{
              display: 'flex',
              alignItems: 'center',
              my: 2,
              py: 2,
              pl: { xs: 3, sm: 0 },
              color: 'primary.main',
              bgcolor: 'rgba(238, 244, 251, 0.5)',
            }}>
            <PersonOutlineOutlinedIcon fontSize="large" />
            <Typography
              sx={{
                fontSize: 20,
                fontWeight: 600,
                pl: 1,
              }}>
              User Management
            </Typography>
          </Box>
        </Hidden>
        <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
          <Box sx={{ display: 'flex', alignItems: 'center' }}>
            <Hidden only="xs">
              <IconButton
                sx={{ height: 'fit-content', p: 0 }}
                onClick={() =>
                  history.push('distributors-rm', {
                    distributorId: distributorRmDetails?.distributorId,
                    isRia: distributorRmDetails?.isRia,
                  })
                }>
                <NavigateBeforeIcon fontSize="medium" sx={{ color: 'common.black' }} />
              </IconButton>
            </Hidden>
            <Typography
              sx={{
                fontSize: 20,
                fontWeight: 600,
                color: '#1C2D47',
                pl: { xs: 2, sm: 0 },
              }}>
              {`${
                checkApplicableForYes(distributorRmDetails?.isRia || '') ? "RIA's" : "Distributor's"
              } RM`}
            </Typography>
          </Box>
          <IconButton>
            <CardMedia
              component="img"
              src="/images/edit-icon-outlined.svg"
              alt="Edit Icon"
              sx={{ width: 'unset' }}
              onClick={() =>
                history.push('edit-distributors-rm', { subDistributorId: distributorRmDetails?.id })
              }
            />
          </IconButton>
        </Box>
        {isLoading ? (
          <LinearProgress sx={{ ml: 5, mr: 5 }} />
        ) : (
          distributorRmDetails && (
            <Grid container sx={{ mt: 1, pl: { xs: 2, sm: 10 }, pr: { xs: 2, sm: 10 }, pt: 1 }}>
              <React.Fragment>
                <Gridstyles>
                  <Grid
                    item
                    container
                    pb={5}
                    rowSpacing={6}
                    columnSpacing={13}
                    direction="row"
                    justifyContent="space-between"
                    alignItems="flex-start">
                    <KeyValue
                      title={`${
                        checkApplicableForYes(distributorRmDetails?.isRia)
                          ? "RIA's"
                          : "Distributor's"
                      } RM name`}
                      description={distributorRmDetails.user.firstName}
                    />
                    <KeyValue title={'Email Id'} description={distributorRmDetails.user.email} />
                    <KeyValue
                      title={'Mobile Number'}
                      description={distributorRmDetails.user.phone}
                    />
                    <KeyValue
                      title={`${
                        checkApplicableForYes(distributorRmDetails?.isRia) ? 'RIA' : 'Distributor'
                      } RM’s NISM Certificate Number`}
                      description={distributorRmDetails?.nismNumber}
                    />
                    <KeyValue title={'Pan'} description={distributorRmDetails.panNumber} />
                    <KeyValue
                      title={`${
                        checkApplicableForYes(distributorRmDetails?.isRia)
                          ? "RIA's"
                          : "Distributor's"
                      }  RM Code`}
                      description={distributorRmDetails.distributors_RM_Code}
                    />
                    {mappingRmWithDistributors && (
                      <KeyValue
                        title={"AMC's RM Name"}
                        description={distributorRmDetails.rm.name}
                      />
                    )}
                    <KeyValue title={'Pincode'} description={distributorRmDetails.pincode} />
                    <KeyValue
                      title={'Building Number'}
                      description={distributorRmDetails.buildingNo}
                    />
                    <KeyValue title={'Street Name'} description={distributorRmDetails.streetName} />
                    <KeyValue title={'State'} description={distributorRmDetails.state} />
                    <KeyValue title={'City'} description={distributorRmDetails.city} />
                    <KeyValue title={'Country'} description={distributorRmDetails.country} />
                  </Grid>
                </Gridstyles>
              </React.Fragment>
            </Grid>
          )
        )}
      </Box>
    </>
  );
}
